import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  addingAddress: false,
  updatingAddress: false,
  countries: [],
  states: [],
  cities: [],
  pickupAddress: [],
  pickupAddressCount: null,
  billingAddress: [],
  billingAddressCount: null,
};

const addressManagementSlice = createSlice({
  name: "addressManagement",
  initialState,
  reducers: {
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },

    fetchPickupAddress(state, action) {
      state.loading = true;
      state.pickupAddress = [];
    },
    fetchPickupAddressSuccess(state, action) {
      state.loading = false;
      state.pickupAddress = action.payload.data.document;
      state.pickupAddressCount = action.payload.count;
    },
    fetchPickupAddressFailure(state, action) {
      state.loading = false;
    },
    fetchBillingAddress(state, action) {
      state.loading = true;
      state.billingAddress = [];
    },
    fetchBillingAddressSuccess(state, action) {
      state.loading = false;
      state.billingAddress = action.payload.data.document;
      state.billingAddressCount = action.payload.count;
    },
    fetchBillingAddressFailure(state, action) {
      state.loading = false;
    },
    addAddress(state, action) {
      state.addingAddress = true;
    },
    addAddressSuccess(state, action) {
      state.addingAddress = false;
    },
    addAddressFailure(state, action) {
      state.addingAddress = false;
      state.error = action.payload.message;
    },
    updateAddress(state, action) {
      state.updatingAddress = true;
    },
    updateAddressSuccess(state, action) {
      state.updatingAddress = false;
    },
    updateAddressFailure(state, action) {
      state.updatingAddress = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.fetchingCountries = false;
      state.fetchingStates = false;
      state.fetchingCities = false;
      state.addingAddress = false;
      state.updatingAddress = false;
      state.countries = [];
      state.states = [];
      state.cities = [];
      state.pickupAddress = [];
      state.pickupAddressCount = null;
      state.billingAddress = [];
      state.billingAddressCount = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = addressManagementSlice;
